// EngagementDetailsPage.jsx

// Dependencies
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Components
import EngagementDetails from '@/components/data/engagements/EngagementDetails';

// Services
import { getEngagement, getEngagementProfessionals, getStartDates } from '@/services/schedulingService';

// Styling
import { homeCss } from '@digital_monorepo/styling';

const EngagementDetailsPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const [engagement, setEngagement] = useState(null);
  const [professionals, setProfessionals] = useState(null);
  const [startDates, setStartDates] = useState(null);

  // Get current week's Monday
  const getStartOfWeek = () => {
    const now = new Date();
    const day = now.getDay();
    const diff = now.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
    const monday = new Date(now.setDate(diff));
    return monday.toISOString().split('T')[0];
  };

  useEffect(() => {
    async function fetchData() {
      try {
        // Get available start dates for the weeks view
        const dates = await getStartDates(false, false, 52); // Get 52 weeks of dates
        setStartDates(dates);
        
        // Get engagement details
        const engagement = await getEngagement(id);
        setEngagement(engagement);
        
        // Get professionals allocated to this engagement
        const professionals = await getEngagementProfessionals(id);
        
        // If no professionals have StartDate, add current week's start date
        const currentStartDate = getStartOfWeek();
        const processedProfessionals = professionals.map(prof => ({
          ...prof,
          StartDate: prof.StartDate || currentStartDate
        }));
        
        setProfessionals(processedProfessionals);
      } catch (error) {
        console.error('Error fetching engagements data:', error);
        const mockStartDate = getStartOfWeek();
        setEngagement(
          {
            EngagementID: '201',
            EngagementName: 'BBC - Documentary',
            Client: 'British Broadcasting Corporation',
            ClientCode: 'BBC',
            Type: 'External',
            Status: 'Online',
            Manager: '',
            EngagementRC: 'PT1',
            EngagementAlias: '',
            EngagementNotes: ''
          }
        );
        setProfessionals(
          [
            {
              ProfessionalID: '101',
              ProfessionalName: 'Joana',
              FunctionLevel: '1000',
              FunctionName: 'Analista',
              Office: 'Porto',
              ProfessionalRC: 'PT1',
              ProfessionalNotes: '',
              StartDate: mockStartDate,
              Hours: 40
            },
            {
              ProfessionalID: '102',
              ProfessionalName: 'Paulo',
              FunctionLevel: '2000',
              FunctionName: 'Consultor',
              Office: 'Porto',
              ProfessionalRC: 'PT1',
              ProfessionalNotes: '',
              StartDate: mockStartDate,
              Hours: 40
            }
          ]
        );
        setStartDates([{ StartDate: mockStartDate }]);
      }
    }

    fetchData();
  }, [id]);

  return (
    <div className={homeCss.container}>
      <div className={homeCss.mainContent}>
        <p className={homeCss.description}>{t('HOMEPAGE.ENGAGEMENTS.TITLE')}</p>
        {engagement && professionals && startDates && <EngagementDetails engagement={engagement} professionals={professionals} startDates={startDates} />}
      </div>
    </div>
  );
};

export default EngagementDetailsPage;
